import { render, staticRenderFns } from "./card.vue?vue&type=template&id=247a0650&scoped=true"
import script from "./card.vue?vue&type=script&lang=ts"
export * from "./card.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./card.vue?vue&type=style&index=0&id=247a0650&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "247a0650",
  "26f6be22"
  
)

export default component.exports